// ObjGraphsBarHtml2D.jsx
import React from 'react';
import { connect } from 'react-redux';
import DrilldownList from '../ObjFields/DrilldownList';
import { getProgressBars } from '../../../Utils/Utils';
import { ObjGraphsBarHtml2DCSSStyles } from './ObjGraphsBarHtml2DCSS';

class ObjGraphsBarHtml2D extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'graph', // 'graph' | 'list'
      drillCat1: null, // valeur de la ligne (cat1)
      drillCat2: null, // valeur de la tranche (cat2)
    };
  }

  handleBack = () =>
    this.setState({ mode: 'graph', drillCat1: null, drillCat2: null });

  render() {
    const { mode, drillCat1, drillCat2 } = this.state;
    const {
      data = [],
      objId,
      formulaCat1,
      formulaCat2,
      extraCondition,

      // optionnels pour l’entête DrilldownList (couleurs/icônes/libellés)
      cat1Meta,
      cat2Meta,
      cat1Label,
      cat2Label,

      // palette & réglages
      colors = [
        '#228BE6',
        '#8a89a6',
        '#7b6888',
        '#6b486b',
        '#a05d56',
        '#d0743c',
        '#ff8c00',
      ],
      widthMode = 'global', // 'global' (par défaut) | 'row'
      profiles,
    } = this.props;

    // somme globale (sert au % si widthMode='global')
    const sum = data.reduce(
      (acc, elem) => acc + (parseInt(elem.result, 10) || 0),
      0
    );

    // domaines cat1 / cat2
    let xses = [...new Set(data.map((item) => item[formulaCat1]))];
    let yses = [...new Set(data.map((item) => item[formulaCat2]))].sort(
      (a, b) => {
        // tri numérique si possible, sinon alphanum
        const na = Number(a);
        const nb = Number(b);
        if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
        return String(a).localeCompare(String(b));
      }
    );

    // matrice valeurs [ligne xses][col yses]
    const matrix = Array.from({ length: xses.length }, () =>
      Array.from({ length: yses.length }, () => 0)
    );
    for (const item of data) {
      const xval = item[formulaCat1];
      const yval = item[formulaCat2];
      const resval = Number(item[Object.keys(item)[0]]) || 0;
      const ix = xses.indexOf(xval);
      const iy = yses.indexOf(yval);
      if (ix >= 0 && iy >= 0) matrix[ix][iy] += resval;
    }

    // callbacks pour getProgressBars
    const onSegmentClick = (segIndex, value, rowLabel) => {
      // drilldown segment: cat1 = ligne, cat2 = à partir de l’index segment
      this.setState({
        mode: 'list',
        drillCat1: rowLabel,
        drillCat2: yses[segIndex],
      });
    };
    const onLabelClick = (rowLabel) => {
      // drilldown de ligne complète: cat1 seul
      this.setState({ mode: 'list', drillCat1: rowLabel, drillCat2: null });
    };

    if (mode === 'list') {
      return (
        <div style={ObjGraphsBarHtml2DCSSStyles.container}>
          <DrilldownList
            title={this.props.title}
            objId={objId}
            formulaCat1={formulaCat1}
            formulaCat2={formulaCat2}
            cat1={drillCat1}
            cat2={drillCat2}
            extraCondition={extraCondition}
            profiles={profiles}
            onBack={this.handleBack}
            // meta / labels optionnels (pour badges)
            cat1Meta={cat1Meta}
            cat2Meta={cat2Meta}
            cat1Label={cat1Label || formulaCat1}
            cat2Label={cat2Label || formulaCat2}
          />
        </div>
      );
    }

    // rendu graph
    return (
      <div style={ObjGraphsBarHtml2DCSSStyles.container}>
        {xses.map((xVal, rowIdx) =>
          getProgressBars(
            sum,
            matrix[rowIdx],
            xVal,
            colors,
            '', // unit
            12, // fontSize
            {
              onSegmentClick,
              onLabelClick,
              yLabels: yses,
              widthMode, // 'global' (elem/sum) ou 'row' (elem/sumLine)
              cursor: 'pointer',
            }
          )
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    profiles: state.objects?.profiles || {},
  };
}

export default connect(mapStateToProps)(ObjGraphsBarHtml2D);
